<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Add Exceptional Days
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <label class="form-label text-label-dark">Employee Type:</label>
            </div>
            <div class="col-md-4">
                <div class="btn-group btn-group-toggle">
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                            [(ngModel)]="Filter.EmpType" (change)="GetEmpType()" [ngModelOptions]="{standalone: true}"
                            required>
                        Front Office
                    </label>
                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                            [(ngModel)]="Filter.EmpType" (change)="GetEmpType()" [ngModelOptions]="{standalone: true}"
                            required>
                        Back Office
                    </label>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <!-- <div class="col-md-3"> -->
            <div class="row">
                <div class="col-auto">
                    <label>Year</label>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Years" bindLabel="Year" bindValue="Year" placeholder="Select Year"
                        [(ngModel)]="Filter.Year" name="Year">
                    </ng-select>
                </div>

                <div class="col-auto">
                    <label>Date</label>
                </div>
                <div class="col-md-3">
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="Date" [(ngModel)]="Filter.Date"
                            ngbDatepicker #Date="ngbDatepicker" required />
                        <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                            (click)="Date.toggle()"></button>
                    </div>
                </div>

                <div class="col-auto mx-2 mt-1">
                    <button class="btn btn-primary btn-sm">
                        <i class="bi bi-plus-circle"></i> Add
                    </button>
                </div>
            </div>
            <!-- <label>Year<span class="text-danger">*</span></label>
                <ng-select [items]="Years" bindLabel="Year" bindValue="Year" placeholder="Select Year"
                    [(ngModel)]="Filter.Year" name="Year">
                </ng-select> -->
            <!-- </div> -->

            <!-- <div class="col-md-3">
                <label>Date<span class="text-danger">*</span></label>
                <div class="input-group">
                    <input class="form-control" placeholder="dd-mm-yyyy" name="Date" [(ngModel)]="Filter.Date"
                        ngbDatepicker #Date="ngbDatepicker" required />
                    <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                        (click)="Date.toggle()"></button>
                </div>
            </div> -->

            <!-- <div class="col-md-6">
                <label>Branch<span class="text-danger">*</span></label>
                <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    placeholder="Select Branch" [(ngModel)]="Filter.Branch" (change)="ComboLoad('Site')" name="Branch">
                </ng-select>
            </div> -->
        </div>

        <div class="row">
            <!-- <div class="col-md-4">
                <label>Date<span class="text-danger">*</span></label>
                <div class="input-group">
                    <input class="form-control" placeholder="dd-mm-yyyy" name="Date" [(ngModel)]="Filter.Date"
                        ngbDatepicker #Date="ngbDatepicker"
                        required />
                    <button class="btn btn-outline-secondary bi bi-calendar3" type="button"
                        (click)="Date.toggle()"></button>
                </div>
            </div> -->

            <!-- <div class="col-md-6">
                <label>Site<span class="text-danger">*</span></label> -->
                <!-- <ng-select [disabled]="Filter.EmpType == 'BACK'" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                    placeholder="Select Site" [(ngModel)]="Filter.Site" name="Site">
                </ng-select> -->

                <!-- <ng-select [items]="Sites" [multiple]="true" bindLabel="SiteName" name="muliex"
                    [selectableGroup]="false" [selectableGroupAsModel]="false" [closeOnSelect]="false"
                    bindValue="SiteMasterID" [(ngModel)]="Filter.SiteIdObj" placeholder="Select Site" required
                    [disabled]="Filter.EmpType == 'BACK'" (click)="CheckDiselect()">

                    <ng-template ng-header-tmp let-items="items">
                        <input type="checkbox" (change)="CheckAll($event,'Site')" /> Check All
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                            [ngModelOptions]="{ standalone : true }" />
                        {{item.SiteName}}
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                            <span class="ng-value-label">{{item.SiteName}}</span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 1">
                            <span class="ng-value-label">{{items.length - 1}} +...</span>
                        </div>
                    </ng-template>
                </ng-select>
            </div>

            <div class="col-auto mt-4">
                <button (click)="logFilter()" class="btn btn-primary btn-sm">
                    <i class="bi bi-search"></i> Search
                </button>
            </div>
            <div class="col-auto mx-2 mt-4">
                <button class="btn btn-primary btn-sm">
                    <i class="bi bi-plus-circle"></i> Add
                </button>
            </div> -->
        </div> 

        <div class="card mt-3">
                <!-- <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div> -->
                <div class="card-body">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="AttendanceRuleDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && AttendanceRuleDetail.DefaultAttendance">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label class="form-check-label" for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && AttendanceRuleDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.WebESSApplicabilityId}}{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.WebESSApplicabilityId}}{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.WebESSApplicabilityId}}{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- <hr> -->

        <div class="mt-3">
            <table datatable [dtOptions]="common.commonDToptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>Date</th>
                        <th>Branch</th>
                        <th>Site</th>
                        <!-- <th></th> -->
                    </tr>
                </thead>
            </table>
        </div>
    </div>

    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button [routerLink]="['/excdays']" class="btn btn-outline-primary btn-sm"><i
                        class="bi bi-x-lg"></i>Cancel</button>
            </div>
        </div>
    </div>
</div>